var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('h4',[_vm._v("Create category")]),_c('resource-form',{on:{"saved":_vm.returnBack,"cancelled":_vm.returnBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }